//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import filterMixin from '@/mixins/filter';
import viewportMixin from '@/mixins/viewport.mixin';
import SelectField from '@/components/d0822/fields/selectField.vue';

export default {
  // eslint-disable-next-line vue/no-reserved-component-names
  components: { SelectField },
  mixins: [filterMixin, viewportMixin],
  data() {
    return {
      localFilter: {},
      filterNamespace: 'eventList',
    };
  },
  computed: {
    filtersMobileLabel() {
      const count = this.selectedFiltersCount;
      return this.$tc('rt0822.events.filter.mobileLabel', count, { count });
    },
    mobileFiltersModal: {
      get() {
        return this.$store.state.eventsList.mobileFiltersModal;
      },
      set(payload) {
        this.$store.commit('eventsList/SET_MOBILE_FILTERS_MODAL', payload);
      },
    },
    isEmbeddedBlocksHidden: {
      get() {
        return this.$store.state.ui.isEmbeddedBlocksHidden;
      },
      set(payload) {
        this.$store.commit('ui/SET_IS_EMBEDDED_BLOCKS_HIDDEN', payload);
      },
    },
  },
  watch: {
    parsedFilter() {
      this.updateLocalFilter();
    },
    mobileFiltersModal(payload) {
      this.isEmbeddedBlocksHidden = payload;
      this.updateLocalFilter();
    },
  },
  methods: {
    apply() {
      this.filterUpdate(this.localFilter);
      this.mobileFiltersModal = false;
    },
    updateLocalFilter() {
      try {
        this.localFilter = JSON.parse(JSON.stringify(this.parsedFilter));
      } catch (e) {
        console.error(e);
      }
    },
  },
};
